export const IsValidNumber = (val: any): boolean =>
  val !== null && val !== undefined && !isNaN(Number(val)) && isFinite(Number(val));